import { useState } from "react";
import useGlobalMutation from "../../../hooks/useGlobalMutation";
import { UPDATE_SITE_ADMIN_USER } from "./query";
import { Loader } from "../../shared";

const ProfileActivation = ({ id, userStatus }) => {
    const { submitMutation, loading } = useGlobalMutation(UPDATE_SITE_ADMIN_USER);
    const [status, setStatus] = useState(userStatus);
    const modalId = `deactivateModal-${id}`;

    const handleProfileActivation = async (status) => {
        const variables = {
            id,
            userPatch: {
                status,
            },
        };
        await submitMutation(
            variables,
            "updateUserById.user",
            `Profile ${status === 1 ? "Activated" : "Deactivated"} Successfully`
        );
        setStatus(status);
    };

    const handleConfirmDeactivation = async () => {
        try {
            await handleProfileActivation(0);

            const modal = document.getElementById(modalId);
            if (modal) {
                document.body.classList.remove("modal-open");
                modal.classList.remove("show");
                modal.setAttribute("aria-hidden", "true");
            }

            const modalBackdrop = document.querySelector(".modal-backdrop");
            if (modalBackdrop) {
                modalBackdrop.remove();
            }
        } catch (error) {}
    };

    return (
        <>
            {loading && <Loader />}
            <div className="row justify-content-center py-3">
                <div className="col-auto">
                    <h6 className="mb-4">
                        Current Status:{" "}
                        <strong className={status === 1 ? "text-success" : "text-danger"}>
                            {status === 1 ? "Active" : "Inactive"}
                        </strong>
                    </h6>

                    {status === 1 ? (
                        <button
                            type="button"
                            className="btn btn-danger px-3 font-weight-bold"
                            data-toggle="modal"
                            data-target={`#${modalId}`}
                            disabled={loading}
                        >
                            Deactivate Profile
                        </button>
                    ) : (
                        <button
                            onClick={() => handleProfileActivation(1)}
                            className="btn btn-primary px-3 font-weight-bold"
                            disabled={loading}
                        >
                            Activate Profile
                        </button>
                    )}
                </div>
            </div>

            {/* Confirm modal, only for deactivation */}
            <div
                className="modal fade"
                id={modalId}
                tabIndex={-1}
                role="dialog"
                aria-labelledby={`${modalId}-label`}
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id={`${modalId}-label`}>
                                Confirm Deactivation
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to deactivate this user?</p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={handleConfirmDeactivation}
                                disabled={loading}
                            >
                                {loading ? "Deactivating..." : "Deactivate"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProfileActivation;
